export default __webpack_public_path__ + "static/media/marker.515d1e03.svg";